import { useState, useEffect } from 'react'
import { DOM_EVENT } from '@/shared/constants/keyboard'

export function useIsOffline(): boolean {
  const [isOffline, setIsOffline] = useState(!navigator.onLine)

  useEffect(() => {
    const goOffline = () => setIsOffline(true)
    const goOnline = () => setIsOffline(false)
    window.addEventListener(DOM_EVENT.OFFLINE, goOffline)
    window.addEventListener(DOM_EVENT.ONLINE, goOnline)
    return () => {
      window.removeEventListener(DOM_EVENT.OFFLINE, goOffline)
      window.removeEventListener(DOM_EVENT.ONLINE, goOnline)
    }
  }, [])

  return isOffline
}
